import { SendInfoMessageFn } from "providers/InfoMessageProvider/InfoMessageProvider";
import React from "react";

export const initialInfoMessageContext = undefined;

export const InfoMessageContext = React.createContext<SendInfoMessageFn | undefined>(initialInfoMessageContext);
InfoMessageContext.displayName = "InfoMessageContext";

export default InfoMessageContext;
